import React from "react";

// Label/value rows shared by the payment terms panel (BreakdownRow, full-bleed
// with its own padding) and the summary sidebar (SummaryRow, inside a card).

export function SummaryRow({ label, value, valueStyle }: { label: string; value: string; valueStyle?: React.CSSProperties }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: "1px solid #ECECEC", fontSize: 14 }}>
      <span style={{ color: "#8c8c8c" }}>{label}</span>
      <span style={valueStyle}>{value}</span>
    </div>
  );
}

export function BreakdownRow({ label, value, valueStyle }: { label: string; value: string; valueStyle?: React.CSSProperties }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "10px 20px", borderBottom: "1px solid #ECECEC", fontSize: 14 }}>
      <span style={{ color: "#8c8c8c" }}>{label}</span>
      <span style={valueStyle}>{value}</span>
    </div>
  );
}
